export const CURRENCY_SYMBOLS = {
  GBP: "£",
  USD: "$",
  EUR: "€",
  ZAR: "R",
  AUD: "A$",
};

export const formatCurrency = (amount, currency = "GBP") => {
  const symbol = CURRENCY_SYMBOLS[currency] || currency + " ";
  const value = Number(amount || 0).toLocaleString("en-GB", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${symbol}${value}`;
};

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso;
  }
};

export const todayISO = () => new Date().toISOString().slice(0, 10);

export const addDaysISO = (days) => {
  const d = new Date();
  d.setDate(d.getDate() + Number(days || 0));
  return d.toISOString().slice(0, 10);
};

export const STATUS_OPTIONS = ["Draft", "Sent", "Paid", "Overdue"];

export const STATUS_STYLES = {
  Draft: "bg-muted text-muted-foreground border-border",
  Sent: "bg-accent text-accent-foreground border-primary/30",
  Paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Overdue: "bg-rose-50 text-rose-700 border-rose-200",
};
